import React, { useEffect, useState } from "react";
import CallServiceTable from "../../components/Tables/CallServiceTable";
import TableComplete from "../../components/Tables/TableComplete";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import * as Yup from "yup";
import { requestAuth } from "../../components/services/RequestService";
import SubModal from "../../components/Modal/SubModal";
import {
  adjuntarDex,
  readDam,
  readDim,
  readEP,
  readParte,
} from "../../components/services/ReadFile";
import { H1, H3, Anchor } from "../../components/Text";
import { useDialog } from "../../contexts/DialogContext";
import { useModal } from "../../contexts/ModalContext";
import { Button } from "../../components/Buttons";
import { DialogConfirmation } from "../../components/Modal";
import { validateType } from "../../utils/constant";
import { Request } from "../../hooks/Request";
import RenderPdf from "../../containers/ManegeProcedure/RenderPdf";
import GenerateRoadmap from "../../containers/ManegeProcedure/GenerateRoadmap";
import FormReadPdf from "../../containers/ManegeProcedure/FormReadPdf";
import FormReadDocument from "../../containers/ManegeProcedure/FormReadDocument";
import FormReadDocumentDimWithFiles from "../../containers/ManegeProcedure/FormReadDocumentDimWithFiles";
// import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
// import RenderProforma from "../../containers/ManegeProcedure/RenderProforma";
import { validateStatus, validateArray } from "../../utils/validate";
import { useAuth } from "../../contexts/AuthContext";
import { headerList } from "../../utils/constant";
import ListDocument from "../../components/common/ListDocument";
import { FormQuotes } from "../../containers/ManegeProcedure/FormQuotes";
import { GenerateExpenseSheetPDF } from "../../containers/ManegeProcedure/GenerateExpenseSheetPDF";
import { DeliveryOfDocumentsPDF } from "../../containers/ManegeProcedure/DeliveryOfDocumentsPDF";
import { GenerateRoadmapPDF } from "../../containers/ManegeProcedure/GenerateRoadmapPDF";
import { FormDeliveryOfDocuments } from "../../containers/ManegeProcedure/FormDeliveryOfDocuments";
import { FormExpenseSheet } from "../../containers/ManegeProcedure/FormExpenseSheet";
import { FormWorkSheet } from "../../containers/ManegeProcedure/FormWorkSheet";
import { ListDocumentDIM } from "../../components/common/ListDocumentDIM";
import { FormDocument } from "../../containers/ManegeProcedure/FormDocument";
import { useReadQueue } from "../../contexts/ReadQueueContext";

const ManegeProcedure = () => {
  const [dataCampo, setdataCountryside] = useState();
  const [dataProcedimiento, setdataProcedure] = useState();
  const [formCountryside, setFormCountryside] = useState();
  const [formProcedure, setformProcedure] = useState();
  const [reload, setReload] = useState(false);
  const [dataForms, setdataForms] = useState(null);
  const [formFroms, setFormFroms] = useState(false);
  const { user } = useAuth();
  const { enqueueTask } = useReadQueue();

  const { openDialog, dialogClose } = useDialog();
  const { openModal } = useModal();

  function editCountryside(data) {
    setdataCountryside(data);
    setFormCountryside(true);
  }
  function editProcedure(data) {
    setdataProcedure(data);
    setformProcedure(true);
  }
  function editForm(data) {
    setdataForms(data);
    setFormFroms(true);
  }

  function handleOpen(procedure, field, value) {
    if (field.type === "subDataAdd" || field.type === "subData") {
      openDialog(
        <div className="max-w-[600px]">
          <ViewSubData
            procedure={procedure}
            field={field}
            value={value}
            user={user}
          />
        </div>
      );
    } else {
      openDialog(
        <ViewDataset
          procedure={procedure}
          field={field}
          value={value}
          user={user}
        />
      );
    }
  }

  function handleBuilder(value, _, data) {
    if (data.type === "file" || data.type === "fileRead") {
      return (
        <Anchor
          className="underline text-blue-700 hover:decoration-1 hover:text-blue-500"
          href={value}
          target="_blank"
        >
          Abrir enlace
        </Anchor>
      );
    } else if (
      data.type === "controlField" ||
      data.type === "fileStatus" ||
      data.type === "subDataAdd" ||
      data.type === "subData"
    ) {
      return (
        <div
          onClick={() => handleOpen(dataProcedimiento, data, value)}
          className="flex gap-2 hover:text-blue-700 cursor-pointer"
        >
          <div className="">
            {value} {data.type === "fileStatus" ? "Abrir" : ""}{" "}
          </div>
          <i className="fas fa-external-link-alt"></i>
        </div>
      );
    }
    return value ?? "-";
  }

  function listDocumentPdf(procedure) {
    openDialog(<RenderPdf procedure={procedure} />);
  }
  function handleDocument(procedure) {
    openModal(<ListDocumentDIM procedure={procedure} />);
    // openModal(<ListDocument procedure={procedure} />);
  }
  // function generateSettlementProforma(procedure) {
  //   openDialog(<RenderLiquidaciónProforma procedure={procedure} />);
  // }

  // function generateProforma(procedure) {
  //   openDialog(<RenderProforma procedure={procedure} />);
  // }

  function generateRoadmap(procedure) {
    // openDialog(<GenerateRoadmap procedure={procedure} />);
    openDialog(<GenerateRoadmapPDF procedure={procedure} />);
  }

  function handleFormQuotes(procedure) {
    openModal(<FormQuotes procedure={procedure} />);
  }
  function handleExpenseSheet(procedure) {
    openModal(<FormExpenseSheet procedure={procedure} />);
    // openDialog(<GenerateExpenseSheetPDF procedure={procedure} />);
  }
  function handleDeliveryOfDocuments(procedure) {
    openModal(<FormDocument procedure={procedure} />);
    // openModal(<FormDeliveryOfDocuments procedure={procedure} />);
    // openDialog(<DeliveryOfDocumentsPDF procedure={procedure} />);
  }
  function handleWorkSheet(procedure) {
    openModal(<FormWorkSheet procedure={procedure} />);
    // openDialog(<DeliveryOfDocumentsPDF procedure={procedure} />);
  }

  function generateItems() {
    openDialog(
      <DialogConfirmation
        children={
          <H3>¿Estas seguro que quieres generar el reporte de los tramites?</H3>
        }
        onClose={dialogClose}
        method="put"
        url="/files/generalFormat"
        texBtn="Generar"
        handleSuccess={viewLinkExcel}
      />
    );
  }
  function generateArchive() {
    openDialog(
      <DialogConfirmation
        children={
          <H3>¿Estas seguro que quieres generar el reporte de archivo?</H3>
        }
        onClose={dialogClose}
        method="put"
        url="/files/archiveFormat"
        texBtn="Generar"
        handleSuccess={viewLinkExcel}
      />
    );
  }

  function viewLinkExcel(data) {
    openDialog(
      <div className="w-[300px]">
        <H3>Archivo generado</H3>
        <center>
          <Anchor
            className="text-[#264fbe] text-[1.4rem]"
            href={data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar archivo
          </Anchor>
        </center>
        <br />
      </div>
    );
  }

  function handleDelete(procedure, reload) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el tramite?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/procedure/${procedure.id}`}
        texBtn="Eliminar"
        handleSuccess={reload}
      />
    );
  }

  function handleReadPdf() {
    openModal(<FormReadPdf />);
  }

  function readDocument() {
    openModal(<FormReadDocument />);
  }

  function readDocumentDimFiles() {
    openModal(<FormReadDocumentDimWithFiles />);
  }


  const newHeaderList = [
    {
      name: "nroInterno",
      label: "Nro de Interno",
      type: "custom",
      builder: (value, __, data) => {
        return (
          <div className="text-blue-500 font-semibold">
            {value || data["NRO INTERNO"] || "-"}
          </div>
        );
      },
    },
    {
      name: "creationDate",
      label: "Fecha de inicio",
      type: "date",
    },
    {
      name: "stepDetail",
      label: "Paso actual",
    },
    {
      name: "razonSocial",
      label: "Cliente",
    },
    {
      name: "isFel",
      label: "Factura/Planilla",
      type: "custom",
      builder: (__, _, data) => {
        const isFel = data["isFel"];
        const isPla = data["isPla"];
        return (
          <div className="flex gap-4">
            <div className="font-semibold">
              {isFel ? `FEL-${data.invoiceNumber}` : "-"}
            </div>
            <div className="font-semibold">
              {isPla ? "PLA" : "-"}
            </div>
          </div>
        );
      },
    },
    {
      name: "descripciónDeLaMercancía",
      label: "Mercadería",
      type: "custom",
      builder: (value, _, data) => {
        const val = value || data["DESCRIPCIÓN DE LA MERCANCÍA"] || null;

        return (
          <div className="font-semibold">
            {val || "-"}
          </div>
        );
      },
    },
    {
      name: "a4AduanaDeDespacho",
      label: "Aduana",
      type: "custom",
      builder: (value, _, data) => {
        const val = value || data["ADUANA DE DESPACHO"] || null;
        return (
          <div>
            {val || "-"}
          </div>
        );
      },
    },
    {
      name: "a1NúmeroDeDeclaración",
      label: "Nro. DIM/DEX",
      type: "custom",
      builder: (value, _, data) => {
        const val = value || data["A1 NÚMERO DE DECLARACIÓN"] || null;
        return (
          <div>
            {val || "-"}
          </div>
        );
      },
    },
    {
      name: "isPla",
      label: "Planillado",
      type: "custom",
      builder: (value, _, data) => {
        const val = value || data["isPla"] || null;
        const bg = val ? "bg-green-100" : "bg-gray-100";
        return (
          <div className={`w-full h-full flex items-center justify-start p-1 rounded-lg text-xs ${bg}`}>
            {val ? "Planillado" : "Pendiente por planillar"}
          </div>
        );
      },
    },
    {
      name: "isFel",
      label: "Facturado",
      type: "custom",
      builder: (value, _, data) => {
        const val = value || data["isFel"] || null;
        const bg = val ? "bg-green-100" : "bg-gray-100";
        return (
          <div className={`w-full h-full flex items-center justify-start p-1 rounded-lg text-xs ${bg}`}>
            {val ? "Facturado" : "Pendiente por facturar"}
          </div>
        );
      },
    },
  ];


  return (
    <>
      <CallServiceTable
        reload={reload}
        component={({ reload }) => {
          return (
            <>
              {/* <Button
                position="left"
                content="Generar reporte"
                onClick={() => handleReadPdf(reload)}
              >
                <i className="fas fa-file-contract"></i>
              </Button>
              <Button
                position="left"
                content="Generar reporte"
                onClick={() => generateItems(reload)}
              >
                <i className="fas fa-book"></i>
              </Button>
              <Button
                position="left"
                content="Generar reporte de archivo"
                onClick={() => generateArchive(reload)}
              >
                <i className="fas fa-archive"></i>
              </Button> */}
              <Button
                position="left"
                content="Leer documentos de la DIM"
                onClick={() => readDocumentDimFiles(reload)}
              >
                <i className="fas fa-archive"></i>
              </Button>
            </>
          );
        }}
        filters={[
          {
            name: "ProcedureTypeId",
            url: "/procedureType",
            default: "Todos los tramites",
            valueOption: "id",
            labelOption: "name",
          },
          {
            name: "CompanyId",
            url: "/company/getCompaniesBySelect",
            default: "Todas las compañías",
            valueOption: "id",
            labelOption: "razonSocial",
          },
        ]}
        urlApi="/procedure/pag"
        aditionalParams={{
          Fieldnames: [
            "nroInterno",
            "codigoDeInterno",
            "descripciónDeLaMercancía",
            "a4AduanaDeDespacho",
            "a1NúmeroDeDeclaración",
          ],
          dateQuery: "CreationDate",
        }}
        addFilters={[
          {
            name: "nroInterno",
            label: "Nro de Interno",
            filter: true,
          },
          {
            name: "a1NúmeroDeDeclaración",
            label: "Nro. DIM/DEX",
            filter: true,
          },
          {
            name: "descripciónDeLaMercancía",
            label: "Mercadería",
            filter: true,
          },
          {
            name: "a4AduanaDeDespacho",
            label: "Aduana",
            filter: true,
          },
          {
            name: "canal(Rojo,AmarilloOVerde)",
            label: "Canal",
            filter: true,
          },
        ]}
        header={[
          ...newHeaderList,
          {
            name: "manage",
            type: "action",
            label: "Gestionar",
            sticky: true,
            actions: [
              {
                label: "Generar hoja de ruta",
                icon: "fas fa-route",
                action: generateRoadmap,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Cotización",
                icon: "fas fa-hand-holding-usd",
                action: handleFormQuotes,
                color: "text-[#1d4ed8]",
              },
              // {
              //   label: "Planilla de gastos",
              //   icon: "fas fa-money-check",
              //   action: handleExpenseSheet,
              //   color: "text-[#1d4ed8]",
              // },
              {
                label: "Entrega de documentos",
                icon: "fas fa-handshake",
                action: handleDeliveryOfDocuments,
                color: "text-[#1d4ed8]",
              },
              // {
              //   label: "Hoja de trabajo",
              //   icon: "fas fa-file-alt",
              //   action: handleWorkSheet,
              //   color: "text-[#1d4ed8]",
              // },
              {
                label: "Ver documentos",
                icon: "fa-solid fa-folder",
                action: handleDocument,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Editar trámite",
                icon: "fas fa-edit",
                action: editCountryside,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Editar valores",
                icon: "fas fa-th-list",
                action: editProcedure,
                color: "text-[#1d4ed8]",
              },
              {
                label: "Eliminar tramite",
                icon: "fas fa-trash",
                action: handleDelete,
                color: "text-[#ff2d55]",
              },




            ],
          },
        ]}
      />
      <SubModal
        setactivateForm={setFormCountryside}
        activateForm={formCountryside}
      >
        <FormDefault
          tittle="Editar trámite"
          fields={[
            {
              label: "Seleccione la compañía",
              name: "CompanyId",
              aditionalName: "CompanyName",
              typeInput: "select",
              urlApi: "/company/getCompaniesBySelect",
              value: "id",
              labelOption: "razonSocial",
            },
            {
              label: "Seleccione el paso:",
              name: "Step",
              aditionalName: "StepName",
              typeInput: "select",
              urlApi: `/processstep/GetProcessStepsByProcedureTypeId/${dataCampo?.procedureTypeId ? dataCampo.procedureTypeId : ""
                }`,
              value: "step",
              labelOption: "name",
              labelOptionParam: "step",
            },
            {
              label: "Descripción",
              name: "Description",
            },
          ]}
          initialValues={{
            id: dataCampo?.id,
            ProcedureTypeId: dataCampo?.procedureTypeId,
            Step: dataCampo?.step,
            CompanyId: dataCampo?.companyId + "",
            StepName:
              dataCampo?.step +
              (dataCampo?.currentStepName
                ? ". " + dataCampo?.currentStepName
                : ""),
            CompanyName: dataCampo?.companyName || dataCampo?.companyId + "",
          }}
          validationSchema={Yup.object().shape({
            id: Yup.string().required("Este campo es obligatorio"),
            CompanyId: Yup.string().required("Este campo es obligatorio"),
            ProcedureTypeId: Yup.string().required("Este campo es obligatorio"),
            Step: Yup.string().required("Este campo es obligatorio"),
          })}
          onSubmit={(values, resetForm) => {
            requestAuth("put", "/procedure", values)
              .then(() => {
                setFormCountryside(!formCountryside);
                setReload(!reload);
                toast.success("Envio exitoso");
                resetForm();
              })
              .catch(() => {
                toast.error("Error en el envio");
              });
          }}
          buttonName="Editar"
        />
      </SubModal>

      {formProcedure && (
        <SubModal
          setactivateForm={setformProcedure}
          activateForm={formProcedure}
        >
          <CallServiceTable
            reload={reload}
            urlApi={`/field/fieldsbyprocedureId/${dataProcedimiento?.id}`}
            filters={[
              {
                name: "step",
                url: `/processstep/GetProcessStepsByProcedureTypeId/${dataProcedimiento?.procedureTypeId
                  ? dataProcedimiento.procedureTypeId
                  : ""
                  }`,
                label: "Todos los pasos",
                valueOption: "step",
                labelOption: "name",
              },
            ]}
            header={[
              {
                name: "label",
                label: "Nombre",
                filter: true,
              },
              {
                name: "initial",
                label: "Valor",
                filter: false,
                builder: handleBuilder,
                type: "custom",
              },
              {
                name: "editValues",
                type: "action",
                label: "Editar",
                actions: [
                  {
                    label: "Editar valor",
                    icon: "fas fa-file-pen",
                    action: editForm,
                    color: "text-[#1d4ed8]",
                  },
                ],
              },
            ]}
            addUrl={`OrderBy=label`}
            statusPaination={true}
            showTable={false}
            edit={true}
            responsive={true}
          />
        </SubModal>
      )}
      {dataForms && (
        <EditDataset
          dataForms={dataForms}
          setactivateForm={setFormFroms}
          activateForm={formFroms}
          dataProcedimiento={dataProcedimiento}
          setReload={setReload}
          reload={reload}
        />
      )}
    </>
  );
};

const ViewSubData = (props) => {
  const { procedure, field, value, user } = props;

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${procedure.id}/field/${field.id}/subdata`,
  });

  return (
    <div>
      {!loading ? null : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Campo",
              },
              {
                name: "description",
                label: "Observación",
              },
              // {
              //   name: "add",
              //   type: "action",
              //   label: "Opciones",
              //   sticky: true,
              //   actions: [
              //     {
              //       label: "Editar",
              //       icon: "fas  fa-edit",
              //       action: handleForm,
              //       color: "text-[#1d4ed8]",
              //     },
              //     {
              //       label: "Añadir",
              //       icon: "fas fa-trash",
              //       action: handleDelete,
              //       color: "text-red-500",
              //     },
              //   ],
              // },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const ViewDataset = (props) => {
  const { procedure, field, value, user } = props;
  const { data, loading } = Request({
    urlApi: `/fileState/procedure/${procedure.id}/field/${field.id}`,
  });
  const headFileStatus = [
    {
      name: "number",
      label: "Nro",
    },
    {
      name: "url",
      label: "Enlace",
      type: "custom",
      builder: (item) => {
        if (item) {
          return (
            <Anchor
              href={item}
              className="text-[#1d4ed8] underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Abrir
            </Anchor>
          );
        } else {
          return "-";
        }
      },
    },
    {
      name: "creationDate",
      label: "Fecha de creación",
      type: "date",
    },
    {
      name: "presentation",
      label: "Presentación",
    },
    {
      name: "status",
      label: "Estado",
    },
    {
      label: "Proveedor",
      name: "provider",
    },
  ];

  const headControlField = [
    {
      name: "url",
      label: "Enlace",
      type: "custom",
      builder: (item) => {
        if (item) {
          return (
            <Anchor
              href={item}
              className="text-[#1d4ed8] underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Abrir
            </Anchor>
          );
        } else {
          return "-";
        }
      },
    },
    {
      name: "creationDate",
      label: "Fecha de creación",
      type: "date",
    },
    {
      name: "description",
      label: "Descripción",
    },
  ];

  if (!loading) {
    return null;
  }
  return (
    <div>
      <H1>{field.label}</H1>
      {field.type === "controlField" && (
        <H3 className="font-normal text-start mb-2">
          <strong>Descripción:</strong> {value}
        </H3>
      )}

      <TableComplete
        header={field.type === "fileStatus" ? headFileStatus : headControlField}
        data={data}
      />
      <br />
    </div>
  );
};

const EditDataset = (props) => {
  const {
    dataForms,
    activateForm,
    setactivateForm,
    dataProcedimiento,
    setReload,
    reload,
  } = props;
  const { enqueueTask } = useReadQueue();
  const [load, setload] = useState(false);
  const [progressMessage, setProgressMessage] = useState("Listo para extraer");
  const [currentStep, setCurrentStep] = useState(0);
  const [totalSteps, setTotalSteps] = useState(0);
  const [currentFieldName, setCurrentFieldName] = useState("");

  useEffect(() => {
    if (!load) return undefined;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [load]);

  function checkSend(values, resetForm) {
    if (values.type === "file" || values.type === "fileRead") {
      let formData = new FormData();
      formData.append("Name", values.name);
      formData.append("File", values[values.name]);
      formData.append("originalName", values[values.name].name);
      formData.append("Status", "verified");
      formData.append("ProcedureId", dataProcedimiento.id);
      requestAuth("post", "/files", formData).then((res) => {
        onSubmit({ ...values, [values.name]: res.data.url }, resetForm);
      });
    } else {
      onSubmit(values, resetForm);
    }
  }
  function onSubmit(values, resetForm) {
    requestAuth(
      "put",
      `/dataset/editdataset/${values.ProcedureId}/fieldid/${values.FieldId}`,
      { ...values, Value: values[values.name] }
    )
      .then(() => {
        setactivateForm(!activateForm);
        setReload(!reload);
        toast.success("Datos Editados Correctamente");
        resetForm();
      })
      .catch(() => {
        toast.error("Error de Edicion");
      });
  }
  function handleRead() {
    const fieldsToRead = Array.isArray(dataForms) ? dataForms : [dataForms];

    fieldsToRead.forEach((field) => {
      enqueueTask({
        field: {
          ...field,
          name: field.name || field.label,
          label: field.label || field.name,
          url: field.url || field.name || field.label,
          initial: field.initial ?? field.Value ?? false,
          validate: field.validate ?? false,
        },
        procedure: dataProcedimiento,
        source: "manage-procedure",
      });
    });

    setload(false);
    setactivateForm(false);
    toast.info("Se agregó la extracción a la cola global. Puedes seguir usando el sistema y retomarla desde el header.");
  }

  function readFields(index, fields, result) {
    if (index < fields.length) {
      const currentField = fields[index];
      const currentLabel = currentField?.label || currentField?.name || "Documento";

      setCurrentStep(index + 1);
      setTotalSteps(fields.length);
      setCurrentFieldName(currentLabel);
      setProgressMessage(`Procesando documento ${index + 1} de ${fields.length}`);

      switch (currentField.url) {
        case "adjuntarDim":
          readDim(fields, index, dataProcedimiento, result, readFields);
          break;
        case "dimRegularizada":
          readDim(fields, index, dataProcedimiento, result, readFields);
          break;
        case "adjuntarDex":
          adjuntarDex(fields, index, dataProcedimiento, result, readFields);
          break;
        case "documentoDam":
          readDam(fields, index, dataProcedimiento, result, readFields);
          break;
        case "parteDeRecepcion":
          readParte(fields, index, dataProcedimiento, result, readFields);
          break;
        case "ep":
          readEP(fields, index, dataProcedimiento, result, readFields);
          break;
        default:
          setProgressMessage(`No se encontró un procesador para ${currentLabel}`);
          readFields(index + 1, fields, [
            ...result,
            { readStatus: 500, readData: "Procesador no disponible", validate: true },
          ]);
          break;
      }
    } else {
      handleFinishRead(result);
    }
  }

  function handleFinishRead(result) {
    setload(false);
    if (validateArray(result) && validateStatus(result[0]?.readStatus)) {
      setactivateForm(!activateForm);
      setReload(!reload);
      toast.success("Se extrajo los datos con éxito");
    } else {
      toast.error(result[0]?.readData || "No se pudo extraer los datos");
    }
  }

  return (
    <div>
      <SubModal setactivateForm={setactivateForm} activateForm={activateForm}>
        <div className="flex">
          <H1 className="text-start">Editar valor</H1>
          {dataForms.initial && dataForms.type === "fileRead" ? (
            load ? (
              <div className="min-h-[90px] flex flex-col justify-center items-center gap-2 px-2">
                <div className="flex items-center gap-2">
                  <svg className="animate-spin h-[24px]" viewBox="0 0 24 24">
                    <i className="text-[#1d4ed8] font-bold fa-solid fa-circle-notch"></i>
                  </svg>
                  <div className="text-center">
                    <p className="font-semibold text-sm">{progressMessage}</p>
                    {totalSteps > 0 ? (
                      <p className="text-xs text-gray-600">
                        Progreso: {currentStep} / {totalSteps}
                      </p>
                    ) : null}
                    {currentFieldName ? (
                      <p className="text-xs text-gray-600">
                        Documento actual: {currentFieldName}
                      </p>
                    ) : null}
                  </div>
                </div>
                <p className="text-xs text-center text-gray-500">
                  Por favor espera. No cierres la ventana ni cambies de página hasta que termine.
                </p>
              </div>
            ) : null
          ) : null}
        </div>
        <FormDefault
          fields={[
            {
              id: dataProcedimiento.id,
              fieldId: dataForms?.id,
              label: dataForms?.label,
              name: dataForms?.name,
              placeholder: "Complete el campo",
              type: dataForms?.type === "fileRead" ? "file" : dataForms?.type,
              typeInput:
                dataForms?.type === "fileRead" ? "file" : dataForms?.type,
              initial: dataForms?.initial ? dataForms?.initial : null,
              // urlApi: dataForms?.url,
              urlApi: dataForms.url
                ? dataForms.url.includes("/")
                  ? dataForms.url
                  : `/Dropdown/${dataForms.url}/options`
                : "",
              urlInitial: dataForms.url,
              value: "name",
              labelOption: "name",
            },
          ]}
          initialValues={{
            ProcedureId: dataProcedimiento?.id,
            [dataForms?.name]: dataForms?.initial,
            FieldId: dataForms?.id,
            ...dataForms,
          }}
          validationSchema={Yup.object().shape({
            [dataForms?.name]: validateType[dataForms.type] || null,
          })}
          onSubmit={checkSend}
          onRead={handleRead}
          buttonName="Editar"
        />
      </SubModal>
    </div>
  );
};

export default ManegeProcedure;
